import { GetterTree } from 'vuex';
import { IState } from '@/store/modules/common/types';
import { IRootState } from '@/store/types';

const getters: GetterTree<IState, IRootState> = {
  getContext(state: IState) {
    return state.context;
  },
  getProject(state: IState) {
    return state.project;
  },
  getEnvironment(state: IState) {
    return state.environment;
  },
  menuActive(state: IState) {
    return state.menuActive;
  },
  portalView(state: IState) {
    return state.portalSequence[state.portalSequence.length - 1];
  },
  isMultifunctionMenuHide(state: IState) {
    return state.globalConfig?.hide_multifunction_menu;
  }
};

export default getters;
